import React from 'react';

// "G" mark set on a chip outline, paired with the Gomagen wordmark.
export const LogoMark = ({ className = 'h-9 w-9' }) => (
  <svg viewBox="0 0 40 40" className={className} aria-hidden="true" fill="none">
    <g stroke="currentColor" strokeWidth="2" strokeLinecap="round" className="text-signal-400">
      <path d="M13 3v4M20 3v4M27 3v4M13 33v4M20 33v4M27 33v4M3 13h4M3 20h4M3 27h4M33 13h4M33 20h4M33 27h4" />
    </g>
    <rect x="7" y="7" width="26" height="26" rx="5" className="fill-ink-800 stroke-signal-400" strokeWidth="2" />
    <path
      d="M25 15.5a6.5 6.5 0 1 0 1 6.5h-6"
      className="stroke-white"
      strokeWidth="2.6"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

const Logo = () => (
  <span className="flex items-center gap-3">
    <LogoMark />
    <span className="font-display text-lg font-bold leading-none tracking-[0.14em] text-white">
      GOMAGEN<span className="ml-2 font-semibold text-signal-400">LABS</span>
    </span>
  </span>
);

export default Logo;
